<template>
  <footer class="site-footer">
    <div class="container">

      <!-- Footer Main -->
      <div class="footer-main">

        <!-- Brand -->
        <div class="footer-brand">
          <Logo />

          <p class="footer-description">
            {{ $t('footer.description') }}
          </p>
        </div>

        <!-- Navigation -->
        <div class="footer-column">
          <h3>{{ $t('footer.navigationTitle') }}</h3>

          <ul>
            <li>
              <router-link to="/">
                {{ $t('navbar.home') }}
              </router-link>
            </li>

            <li>
              <router-link to="/about">
                {{ $t('navbar.about') }}
              </router-link>
            </li>

            <li>
              <router-link to="/how-it-works">
                {{ $t('navbar.works') }}
              </router-link>
            </li>

            <li>
              <router-link to="/pricing">
                {{ $t('navbar.pricing') }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Information -->
        <div class="footer-column">
          <h3>{{ $t('footer.informationTitle') }}</h3>

          <ul>
            <li>
              <router-link to="/blog">
                {{ $t('footer.blog') }}
              </router-link>
            </li>

            <li>
              <router-link to="/faq">
                {{ $t('footer.faq') }}
              </router-link>
            </li>

            <li>
              <router-link to="/privacy-policy">
                {{ $t('footer.privacy') }}
              </router-link>
            </li>

            <li>
              <router-link to="/terms-of-service">
                {{ $t('footer.terms') }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-column footer-contact">
          <h3>{{ $t('footer.contactTitle') }}</h3>

          <p>
            {{ $t('footer.contactDescription') }}
          </p>

          <Icon />
        </div>

      </div>

      <!-- Bottom Footer -->
      <div class="footer-bottom">
        <p>
          © {{ currentYear }} Ditap.
        </p>

        <p class="footer-made">
          {{ $t('footer.rights') }}
        </p>
      </div>

    </div>
  </footer>
</template>

<script>
import Logo from '@/components/common/Logo.vue'
import Icon from '@/components/common/Icon.vue'

export default {
  name: 'FooterPage',

  components: {
    Logo,
    Icon
  },

  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
</style>